import React from "react";

const PrintTableTitle = ({ color, title: { mainTitle, subTitle }, noPageBreak = false }) => {
  return (
    <div className="print-body-title">
      <h2 style={{ color }}>{mainTitle}</h2>
      {subTitle && <h3 className={noPageBreak ? 'no-page-break' : ''}>{subTitle}</h3>}
    </div>
  );
};

export default PrintTableTitle;
